module.exports = __webpack_public_path__ + "img/memory_game.727a00e3.png";